/* Chris 31.10: Clerk's search window (my.clerk.io, Omnisearch) as part of the shop.
   1. The window starts where the header's top row starts, so its search field lands
      exactly on the header's field instead of jumping (assets/dr-clerk.css lays out the
      bar like the header). On the phone, where Clerk shows no logo, the header's is used.
   2. «Sorter etter» is drawn as the shop's own drop-down instead of the browser's. The
      browser's select stays in the page, hidden; choosing in ours sets it and tells Clerk,
      so Clerk sorts as before.
   3. Chris 3.11: categories as cards with a picture (two across on the phone) and pages as
      rows with an icon, instead of Clerk's plain words. The pictures come from
      sections/dr-clerk-bilder.liquid, fetched once. Clerk's links go to the myshopify
      address; they are made relative so the customer stays on drommerom.no. Before the
      customer types, the categories are the front page's «Populære kategorier». */
(function () {
  function plasser(overlay) {
    var rad = document.querySelector('header-component .header__row--top');
    var topp = rad ? Math.max(0, Math.round(rad.getBoundingClientRect().top)) : 0;
    overlay.style.setProperty('--dr-clerk-topp', topp + 'px');

    // Clerk leaves its logo out on the phone; borrow the header's so the bar looks the same.
    var bar = overlay.querySelector('#clerk-omni-search-topbar');
    var logo = document.querySelector('header-component .header-logo');
    if (bar && logo && !bar.querySelector('.logo-wrapper')) {
      var kopi = logo.cloneNode(true);
      kopi.className = 'logo-wrapper dr-clerk-logo';
      kopi.removeAttribute('style');
      bar.insertBefore(kopi, bar.firstChild);
    }
  }

  function lukkAlle(unntatt) {
    document.querySelectorAll('.dr-clerk-sorter.is-open').forEach(function (s) {
      if (s !== unntatt) {
        s.classList.remove('is-open');
        s.querySelector('.dr-clerk-sorter__knapp').setAttribute('aria-expanded', 'false');
      }
    });
  }

  function byggSorter(select) {
    if (select.dataset.drSorter) return;
    select.dataset.drSorter = '1';

    var boks = document.createElement('div');
    boks.className = 'dr-clerk-sorter';
    var knapp = document.createElement('button');
    knapp.type = 'button';
    knapp.className = 'dr-clerk-sorter__knapp';
    knapp.setAttribute('aria-haspopup', 'listbox');
    knapp.setAttribute('aria-expanded', 'false');
    var liste = document.createElement('ul');
    liste.className = 'dr-clerk-sorter__liste';
    liste.setAttribute('role', 'listbox');

    function navn(opt) {
      return opt.textContent.replace(/\s+/g, ' ').trim();
    }

    function tegn() {
      var valgt = select.options[select.selectedIndex];
      knapp.textContent = 'Sorter: ' + (valgt && valgt.value ? navn(valgt) : 'Mest relevant');
      liste.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (opt) {
        if (!opt.value) return;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.tabIndex = -1;
        li.dataset.verdi = opt.value;
        li.textContent = opt.value === 'default' ? 'Mest relevant' : navn(opt);
        if (opt.selected || (!select.value && opt.value === 'default')) li.setAttribute('aria-selected', 'true');
        liste.appendChild(li);
      });
    }

    knapp.addEventListener('click', function () {
      var apen = !boks.classList.contains('is-open');
      lukkAlle(boks);
      boks.classList.toggle('is-open', apen);
      knapp.setAttribute('aria-expanded', apen ? 'true' : 'false');
      if (apen) {
        var valgt = liste.querySelector('[aria-selected="true"]') || liste.firstElementChild;
        if (valgt) valgt.focus();
      }
    });

    liste.addEventListener('click', function (e) {
      var li = e.target.closest('li[data-verdi]');
      if (!li) return;
      select.value = li.dataset.verdi;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      boks.classList.remove('is-open');
      knapp.setAttribute('aria-expanded', 'false');
      tegn();
      knapp.focus();
    });

    liste.addEventListener('keydown', function (e) {
      var li = document.activeElement;
      if (e.key === 'ArrowDown' && li.nextElementSibling) { e.preventDefault(); li.nextElementSibling.focus(); }
      if (e.key === 'ArrowUp' && li.previousElementSibling) { e.preventDefault(); li.previousElementSibling.focus(); }
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); li.click(); }
      if (e.key === 'Escape') { boks.classList.remove('is-open'); knapp.setAttribute('aria-expanded', 'false'); knapp.focus(); }
    });

    select.addEventListener('change', tegn);
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    select.classList.add('dr-clerk-sorter__skjult');
    boks.appendChild(knapp);
    boks.appendChild(liste);
    select.insertAdjacentElement('afterend', boks);
    tegn();
  }

  var IKONER = {
    telefon: '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/>',
    frakt: '<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/>',
    retur: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>',
    sporsmal: '<circle cx="12" cy="12" r="9"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01"/>',
    butikk: '<path d="M3 9l1.5-5h15L21 9M4 9v11h16V9M3 9h18M9 20v-6h6v6"/>',
    guide: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5v14zM20 17v4H6.5A2.5 2.5 0 0 1 4 19.5"/>',
    side: '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6M8 13h8M8 17h5"/>'
  };

  function ikonFor(sti) {
    if (/kontakt|contact/.test(sti)) return 'telefon';
    if (/frakt|levering/.test(sti)) return 'frakt';
    if (/retur|reklamasjon/.test(sti)) return 'retur';
    if (/sporsmal|infosenter/.test(sti)) return 'sporsmal';
    if (/showroom|fabrikk/.test(sti)) return 'butikk';
    if (/^\/blogs\//.test(sti)) return 'guide';
    return 'side';
  }

  var bilder = null;
  var populaere = null;
  var henter = false;

  function hentBilder() {
    if (henter) return;
    henter = true;
    var rot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(rot + '?section_id=dr-clerk-bilder')
      .then(function (svar) { return svar.ok ? svar.text() : ''; })
      .then(function (html) {
        var side = new DOMParser().parseFromString(html, 'text/html');
        var data = side.querySelector('[data-dr-clerk-bilder]');
        var liste = side.querySelector('[data-dr-clerk-populaere]');
        bilder = data ? JSON.parse(data.textContent) : {};
        populaere = liste ? JSON.parse(liste.textContent) : [];
      })
      .catch(function () { bilder = {}; populaere = []; })
      .then(function () {
        var overlay = document.querySelector('.clerk-omnisearch-overlay');
        if (overlay) pynt(overlay);
      });
  }

  function relativ(a) {
    try {
      var url = new URL(a.href);
      if (/myshopify\.com$|drommerom\.no$/.test(url.hostname)) a.setAttribute('href', url.pathname + url.search);
    } catch (e) {}
  }

  // «OFTE STILTE SPØRSMÅL» and «personvernregler» as the shop writes names: a capital first.
  function navnet(a) {
    var el = a.querySelector('.os-list-item');
    var tekst = el ? el.textContent.trim() : '';
    if (!tekst) return;
    if (tekst === tekst.toUpperCase()) tekst = tekst.toLowerCase();
    el.textContent = tekst.charAt(0).toUpperCase() + tekst.slice(1);
  }

  function kort(kategori) {
    var a = document.createElement('a');
    a.className = 'os-link dr-clerk-kat';
    a.href = kategori.url;
    var ramme = document.createElement('span');
    ramme.className = 'dr-clerk-kat__bilde';
    if (kategori.bilde) {
      var img = document.createElement('img');
      img.src = kategori.bilde;
      img.alt = '';
      img.loading = 'lazy';
      ramme.appendChild(img);
    }
    var navn = document.createElement('div');
    navn.className = 'os-list-item os-item-category';
    navn.textContent = kategori.navn;
    a.appendChild(ramme);
    a.appendChild(navn);
    return a;
  }

  // Before the customer types: the front page's popular categories instead of Clerk's random
  // handful (dr-clerk.css hides Clerk's while the list has dr-clerk-tom).
  function populaereKategorier(overlay) {
    var felt = overlay.querySelector('#clerk-omnisearch-input');
    var tom = !!(felt && !felt.value.trim() && populaere && populaere.length);
    overlay.querySelectorAll('.os-list.os-categories').forEach(function (liste) {
      liste.classList.toggle('dr-clerk-tom', tom);
      if (!tom || liste.querySelector('.dr-clerk-populaere')) return;
      var boks = document.createElement('div');
      boks.className = 'os-link-wrapper dr-clerk-populaere';
      populaere.forEach(function (k) { boks.appendChild(kort(k)); });
      liste.appendChild(boks);
    });
  }

  function pynt(overlay) {
    overlay.querySelectorAll('.os-list.os-categories .os-link').forEach(function (a) {
      if (!a.classList.contains('dr-clerk-kat')) {
        relativ(a);
        navnet(a);
        a.classList.add('dr-clerk-kat');
        var ramme = document.createElement('span');
        ramme.className = 'dr-clerk-kat__bilde';
        a.insertBefore(ramme, a.firstChild);
      }
      var ramme = a.querySelector('.dr-clerk-kat__bilde');
      if (!bilder || ramme.firstChild) return;
      var handle = a.getAttribute('href').split('/collections/')[1];
      var src = handle && bilder[handle.split(/[?#]/)[0]];
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        ramme.appendChild(img);
      }
    });
    overlay.querySelectorAll('.os-list.os-pages .os-link:not(.dr-clerk-side)').forEach(function (a) {
      relativ(a);
      navnet(a);
      a.classList.add('dr-clerk-side');
      var ikon = document.createElement('span');
      ikon.className = 'dr-clerk-side__ikon';
      ikon.setAttribute('aria-hidden', 'true');
      ikon.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + IKONER[ikonFor(a.getAttribute('href'))] + '</svg>';
      a.insertBefore(ikon, a.firstChild);
    });
    if (!bilder && overlay.querySelector('.dr-clerk-kat')) hentBilder();
    populaereKategorier(overlay);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.dr-clerk-sorter')) lukkAlle(null);
  });

  document.addEventListener('input', function (e) {
    if (e.target.id !== 'clerk-omnisearch-input') return;
    var overlay = document.querySelector('.clerk-omnisearch-overlay');
    if (overlay) populaereKategorier(overlay);
  });

  function sjekk() {
    var overlay = document.querySelector('.clerk-omnisearch-overlay');
    if (!overlay) return;
    if (overlay.classList.contains('clerk-omnisearch-visible')) plasser(overlay);
    overlay.querySelectorAll('select.clerk-omnisearch-sort').forEach(byggSorter);
    pynt(overlay);
  }

  var planlagt = false;
  new MutationObserver(function () {
    if (planlagt) return;
    planlagt = true;
    requestAnimationFrame(function () {
      planlagt = false;
      sjekk();
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  sjekk();
})();
